import Vue from "vue";
// 引入组件
import vipTan from "./vipTan.vue";

// 创建构造器
const vipTanBox = Vue.extend(vipTan);

vipTan.install = function (data) {
  // 创建组件对象，并挂载
  let instance = new vipTanBox({
    data
  }).$mount(); // $mount(document.createElement('div') 【也可以挂载到某个元素上】

  // 将组件添加到dom中
  document.body.appendChild(instance.$el);
  // 调用方法或操作属性
  Vue.nextTick(() => {
      instance.open();
  });
};

export default vipTan;
